/**
 * Search template ESM (Phase 10).
 *
 * Replaces theme/js/templates/search.js. Toggles between the results
 * header title and the inline search form when the "New Search" button
 * is clicked, slides back when the input loses focus.
 *
 * Source path: theme/js/templates/search.esm.js
 * Built name : ./search.js
 *
 * AI: Entirely written by AI
 * Date: 2026-05-04
 * Model: Claude Opus 4.7
 *
 * [Search]
 */

import { log } from './log.js';
import { slideDown, slideUp } from './core-anim.js';
import { getEasing } from './easing.js';

const NEW_SEARCH_SELECTOR = '.js-new-search-button';
const TITLE_SELECTOR = '#results-header-title';
const FORM_SELECTOR = '#results-header-form';
const SEARCH_INPUT_SELECTOR = '#results-header-form input[name="q"]';
const DURATION = 300;

function showForm() {
  const title = document.querySelector(TITLE_SELECTOR);
  const form = document.querySelector(FORM_SELECTOR);
  if (!title || !form) return;
  const easing = getEasing();
  slideUp(title, { duration: DURATION, easing });
  slideDown(form, { duration: DURATION, easing }).then(() => {
    const input = document.querySelector(SEARCH_INPUT_SELECTOR);
    if (input) input.focus();
  });
}

function showTitle() {
  const title = document.querySelector(TITLE_SELECTOR);
  const form = document.querySelector(FORM_SELECTOR);
  if (!title || !form) return;
  const easing = getEasing();
  slideDown(title, { duration: DURATION, easing });
  slideUp(form, { duration: DURATION, easing });
}

document.addEventListener('click', (event) => {
  const trigger = event.target.closest && event.target.closest(NEW_SEARCH_SELECTOR);
  if (!trigger) return;
  event.preventDefault();
  showForm();
});

document.addEventListener('focusout', (event) => {
  if (event.target && event.target.matches && event.target.matches(SEARCH_INPUT_SELECTOR)) {
    showTitle();
  }
});

log('[Search] registered');
